module.exports = __webpack_public_path__ + "static/media/labyrinth.3a51715e.jpg";